import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  FunnelPlatform,
  FunnelRecurring,
  UserFunnelResponse,
} from '../models/user-funnel';

@Injectable({
  providedIn: 'root',
})
export class UserFunnelService {
  constructor(private http: HttpClient) {}

  getFunnel(params: {
    since: string;
    until: string;
    platform: FunnelPlatform;
    recurring: FunnelRecurring;
    search?: string;
    page?: number;
    page_size?: number;
  }): Observable<UserFunnelResponse> {
    let httpParams = new HttpParams()
      .set('since', params.since)
      .set('until', params.until)
      .set('date_mode', 'signup_cohort')
      .set('progression_scope', 'until_now')
      .set('platform', params.platform)
      .set('recurring', params.recurring);

    if (params.search?.trim()) {
      httpParams = httpParams.set('search', params.search.trim());
    }

    if (params.page) {
      httpParams = httpParams.set('page', String(params.page));
    }

    if (params.page_size) {
      httpParams = httpParams.set('page_size', String(params.page_size));
    }

    return this.http.get<UserFunnelResponse>(`${environment.apiUrl}/admin/accounts/funnel/`, {
      params: httpParams,
    });
  }
}
